import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Ludi from "./pages/ludi";
import KobeM from "./pages/kobem";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

/**
 * App page.
 * Uses React Router to navigate app.
 */
function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Navbar />
        <div className="main-content">
          <Routes>
            {/* Home page */}
            <Route path="/portfolio" element={<Home />} />

            {/* Project pages */}
            <Route path="/portfolio/kobem" element={<KobeM />} />
            <Route path="/portfolio/ludi" element={<Ludi />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
